<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="5">
          <h2>Editar usuário {{ username }}</h2>

          <b-alert v-model="f.show" :variant="f.variant" dismissible>
            {{ f.msg }}
          </b-alert>

          <b-form @submit="onSubmit" class="mb-4">
            <b-form-group
              label="Nome:"
              label-for="input-name"
              description="Informe o nome completo"
            >
              <b-form-input
                id="input-name"
                v-model="form.name"
                type="text"
                required
                :autofocus="true"
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">Editar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AdminUsersEdit',
  props: [
    'username'
  ],
  data () {
    return {
      form: {
        name: this.username
      },
      f: {
        variant: 'danger',
        msg: '',
        show: false
      },
      userId: parseInt(this.$route.params.id)
    }
  },
  methods: {
    async onSubmit (evt) {
      evt.preventDefault()

      try {
        let resp = await this.$http.put(process.env.VUE_APP_URL_APP + `/b/admin/users/${this.userId}`, this.form)

        if (resp.body.ok) {
          return this.$router.push({name: 'AdminUsersList'})
        }
      } catch (err) {
        this.f = {
          msg: err.body.message,
          show: true,
          variant: 'danger'
        }
      }
    }
  }
}
</script>
